import { ACTIVE_INSTALLMENTS } from "../../constants/kasir/constant";

const initialState = {
  dataGetActiveInstallments: {
    count: 0,
    data: [],
  },
  loadingGetActiveInstallments: false,
  dataDetailInstallment: null,
  loadingDetailInstallment: false,
};

const installmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVE_INSTALLMENTS.LOADING_GET_ACTIVE_INSTALLMENTS:
      return {
        ...state,
        loadingGetActiveInstallments: action.load,
      };
    case ACTIVE_INSTALLMENTS.GET_ACTIVE_INSTALLMENTS:
      return {
        ...state,
        dataGetActiveInstallments: action.data,
      };
    case ACTIVE_INSTALLMENTS.LOADING_GET_INSTALLMENT_DETAIL:
      return {
        ...state,
        loadingDetailInstallment: action.load,
      };
    case ACTIVE_INSTALLMENTS.GET_INSTALLMENT_DETAIL:
      return {
        ...state,
        dataDetailInstallment: action.data,
      };
    default:
      return state;
  }
};

export default installmentReducer;
